import React,{ useContext, useEffect, useState } from 'react';
import FormRow from '../../formulario/FormRow';
import MiSelect from '../../formulario/MiSelect';
import FormInput from '../../formulario/FormInput';

import { dateSqlToLocal, getAhoraddmmyyyy, diffDatesToString }from '../../../helpers/helperApp';

import 'bootstrap/dist/css/bootstrap.min.css';

import { Fragment } from 'react';

function Caducidad(props){

    const {estadoForm, loading, formulario, changeSelect, saveFormulario, handleInput, traduction, noDisplay } = props

    const dataCalculable = [
        { "value" : 0, "label" : traduction.cbocalculable.no.title },
        { "value" : 1, "label" : traduction.cbocalculable.si.title }
    ]
        
    const dataTipo = [
        { "value" : 0, "label" : traduction.cbotipo.sincaducidad.title },
        { "value" : 1, "label" : traduction.cbotipo.caducado.title },
        { "value" : 2, "label" : traduction.cbotipo.fecha.title }
    ]

    const dataMetodoF = [
        { "value" : 0, "label" : traduction.cbometodof.dias.title },
        { "value" : 1, "label" : traduction.cbometodof.semanas.title },
        { "value" : 2, "label" : traduction.cbometodof.meses.title },
        { "value" : 3, "label" : traduction.cbometodof.anhos.title }
    ]

     // ***** Funciones que se ejecutan al terminar  de cargar el componente *****
    useEffect(() => {
                

    }, [formulario])

    return(
      <div>
            <FormRow>              
                    <MiSelect  
                        estadoForm=   { estadoForm }
                        val=          { formulario["caducidad.tipo"]  }   
                        loading=      { loading }
                        id=           "caducidad.tipo"    
                        name=         "caducidad.tipo"   
                        label=        { traduction.tipo.title }    
                        placeholder=  { traduction.tipo.title }
                        col=          "3" 
                        isClearable=  "false"
                        isSearchable= "true"
                        dataType=     "codigo"
                        data=         {dataTipo}
                        required=     { false } 
                        disabled=     { false }
                        readOnly =    { estadoForm }
                        disablethisid={null}
                        disableids=   {null}
                        formulario=   { formulario }   
                        change=       { changeSelect }
                    />
                    {
                        formulario["caducidad.tipo"] != 0
                        ?
                            <FormInput                                                        
                                estadoForm= { estadoForm }
                                value=      { formulario["caducidad.preaviso"] }
                                loading=    { loading }
                                id=         "caducidad.preaviso"   
                                type=       "number"
                                name=       "caducidad.preaviso"   
                                label=      { traduction.preaviso.title }                                                       
                                placeholder=""    
                                col=        "2" 
                                required=   { false }
                                readonly=   { formulario["caducidad.tipo"] == 1 ? "readonly" : estadoForm }                                                
                                disabled=   { null }
                                change=     { e => handleInput(e, formulario, saveFormulario) }
                                onBlur=     {null} 
                            />
                        :
                            null
                    }
            </FormRow>
            {
                formulario["caducidad.tipo"] != 0
                    ?
                    <Fragment>
                        <FormRow>
                                    <FormInput                                                        
                                        estadoForm= { estadoForm }
                                        value=      { formulario["caducidad.fecha_evento"] }
                                        loading=    { loading }
                                        id=         "caducidad.fecha_evento"   
                                        type=       "datetime-local"
                                        name=       "caducidad.fecha_evento"   
                                        label=      { traduction.fecha_evento.title }                                                       
                                        placeholder={ traduction.fecha_evento.title }    
                                        col=        "3" 
                                        required=   { false }
                                        readonly=   { "readonly" }   
                                        disabled=   { null }
                                        change=     { e => handleInput(e, formulario, saveFormulario) }
                                        onBlur=     {null} 
                                    />
                                    <MiSelect  
                                        estadoForm=   { estadoForm }
                                        // val=          { formulario["caducidad.calculable"]  }  
                                        val = { formulario["caducidad.tipo"] == 3 || formulario["caducidad.tipo"] == 4 ? 1 : 0} 
                                        loading=      { loading }
                                        id=           "caducidad.calculable"    
                                        name=         "caducidad.calculable"   
                                        label=        { traduction.calculable.title }    
                                        placeholder=  { traduction.calculable.title }
                                        col=          "2" 
                                        isClearable=  "false"
                                        isSearchable= "true"
                                        dataType=     "codigo"
                                        data=         {dataCalculable}
                                        required=     { false } 
                                        disabled=     { false }
                                        readOnly =    { "readonly" }
                                        disablethisid={null}
                                        disableids=   {null}
                                        formulario=   { formulario }   
                                        change=       { changeSelect }
                                    />
                                    <FormInput                                                        
                                        estadoForm= { estadoForm }
                                        value=      { formulario["caducidad.inicio_f"] }
                                        loading=    { loading }
                                        id=         "caducidad.inicio_f"   
                                        type=       "datetime-local"
                                        name=       "caducidad.inicio_f"   
                                        label=      { traduction.inicio_f.title }                                                       
                                        placeholder={ traduction.inicio_f.title }    
                                        col=        "3" 
                                        required=   { false }
                                        readonly=   { formulario["caducidad.tipo"] == 1 ? "readonly" : estadoForm }                                                
                                        disabled=   { null }
                                        change=     { e => handleInput(e, formulario, saveFormulario) }
                                        onBlur=     {null} 
                                    />
                                    <div className={"form-group col-md-4"}>
                                        <label htmlFor="dif">{ traduction.diferencia.title }</label>
                                                {
                                                    diffDatesToString(formulario["caducidad.fecha_evento"], formulario["caducidad.inicio_f"], traduction, true, false) === "future" 
                                                    ?
                                                        <div className="alert alert-warning" role="alert" style={{height: "38px", paddingTop: "6px"}}>
                                                            {diffDatesToString(formulario["caducidad.fecha_evento"], formulario["caducidad.inicio_f"], traduction, true, true)}
                                                        </div>                                                 
                                                    :
                                                        diffDatesToString(formulario["caducidad.fecha_evento"], formulario["caducidad.inicio_f"], traduction, true, false) === "past"
                                                        ?
                                                        <div className="alert alert-danger" role="alert" style={{height: "38px", paddingTop: "6px"}}>
                                                            {diffDatesToString(formulario["caducidad.fecha_evento"], formulario["caducidad.inicio_f"], traduction, true, true)}
                                                        </div>  
                                                        :
                                                        diffDatesToString(formulario["caducidad.fecha_evento"], formulario["caducidad.inicio_f"], traduction, true, false) === "now"
                                                            ?
                                                            <div className="alert alert-success" role="alert" style={{height: "38px", paddingTop: "6px"}}>
                                                                {diffDatesToString(formulario["caducidad.fecha_evento"], formulario["caducidad.inicio_f"], traduction, true, true)}
                                                            </div> 
                                                            :
                                                            null

                                                }
                                    </div>
                            </FormRow>
                        </Fragment>
                    :
                    null
            }

            {
                formulario["caducidad.tipo"] == 2 || formulario["caducidad.tipo"] == 4
                ?
                    <FormRow>
                            <FormInput                                                        
                                estadoForm= { estadoForm }
                                value=      { formulario["caducidad.cantidad_f"] }
                                loading=    { loading }
                                id=         "caducidad.cantidad_f"   
                                type=       "number"
                                name=       "caducidad.cantidad_f"   
                                label=      { traduction.cantidad_f.title }                                                       
                                placeholder=""    
                                col=        "2" 
                                required=   { noDisplay ? false : formulario["caducidad.tipo"] == 2 ? true : false }
                                readonly=   { estadoForm }                                                
                                disabled=   { null }
                                change=     { e => handleInput(e, formulario, saveFormulario) }
                                onBlur=     {null} 
                            />
                            <MiSelect  
                                estadoForm=   { estadoForm }
                                val=          { formulario["caducidad.metodo_f"]  }   
                                loading=      { loading }
                                id=           "caducidad.metodo_f"    
                                name=         "caducidad.metodo_f"   
                                label=        { traduction.metodo_f.title }   
                                placeholder=  ""
                                col=          "2" 
                                isClearable=  "false"
                                isSearchable= "true"
                                dataType=     "codigo"
                                data=         { dataMetodoF }
                                required=     { noDisplay ? false : formulario["caducidad.tipo"] == 2 ? true : false } 
                                disabled=     { false }
                                readOnly =    { estadoForm }
                                disablethisid={null}
                                disableids=   {null}
                                formulario=   { formulario }   
                                change=       { changeSelect }
                            />  
                    </FormRow>
                :
                null
            }
            {
                formulario["caducidad.tipo"] == 3 || formulario["caducidad.tipo"] == 4
                ?
                    <Fragment>
                        <FormRow>
                                <FormInput                                                        
                                    estadoForm= { estadoForm }
                                    value=      { formulario["caducidad.cantidad_e"] }
                                    loading=    { loading }
                                    id=         "caducidad.cantidad_e"   
                                    type=       "number"
                                    name=       "caducidad.cantidad_e"   
                                    label=      { traduction.cantidad_e.title }                                                        
                                    placeholder=""    
                                    col=        "4" 
                                    required=   { noDisplay ? false : formulario["caducidad.tipo"] == 3 || formulario["caducidad.tipo"] == 4 ? true : false }
                                    readonly=   { estadoForm }                                                
                                    disabled=   { null }
                                    change=     { e => handleInput(e, formulario, saveFormulario) }
                                    onBlur=     {null} 
                                />
                        </FormRow>                
                                <FormRow>
                                    <FormInput                                                        
                                        estadoForm= { estadoForm }
                                        value=      { formulario["caducidad.inicio_e"] }
                                        loading=    { loading }
                                        id=         "caducidad.inicio_e"   
                                        type=       "number"
                                        name=       "caducidad.inicio_e"   
                                        label=      {formulario["recurencia.inicio_f"] != "" ?  traduction.inicio_e.title +" "+dateSqlToLocal(formulario["caducidad.inicio_f"]) : traduction.inicio_e.title +" "+formulario["caducidad.inicio_f"]}
                                        placeholder=""    
                                        col=        "4" 
                                        required=   { noDisplay ? false : formulario["caducidad.tipo"] == 3 || formulario["caducidad.tipo"] == 4 ? true : false }
                                        readonly=   { estadoForm }                                                
                                        disabled=   { null }
                                        change=     { e => handleInput(e, formulario, saveFormulario) }
                                        onBlur=     {null} 
                                    />
                                    <FormInput                                                        
                                        estadoForm= { estadoForm }
                                        value=      { formulario["caducidad.actual_e"] }
                                        loading=    { loading }
                                        id=         "caducidad.actual_e"   
                                        type=       "number"
                                        name=       "caducidad.actual_e"   
                                        label=      {formulario["recurencia.actual_e"] != "" ?  traduction.actual_e.title +getAhoraddmmyyyy() : traduction.actual_e.title +formulario["caducidad.actual_e"]}
                                        placeholder=""    
                                        col=        "4" 
                                        required=   { noDisplay ? false : formulario["caducidad.tipo"] == 3 || formulario["caducidad.tipo"] == 4 ? true : false }
                                        readonly=   { estadoForm }                                                
                                        disabled=   { null }
                                        change=     { e => handleInput(e, formulario, saveFormulario) }
                                        onBlur=     {null} 
                                    />
                                    <FormInput                                                        
                                        estadoForm= { estadoForm }
                                        value=      { formulario["caducidad.media_e"] }
                                        loading=    { loading }
                                        id=         "caducidad.media_e"   
                                        type=       "number"
                                        name=       "caducidad.media_e"   
                                        label=      { traduction.media_e.title }
                                        placeholder=""    
                                        col=        "4" 
                                        required=   { null }
                                        readonly=   { "readonly" }                                                
                                        disabled=   { null }
                                        change=     { e => handleInput(e, formulario, saveFormulario) }
                                        onBlur=     {null} 
                                    />
                                </FormRow>                       
                    </Fragment>

                :
                null
            }



      </div>
    )
}

export default Caducidad;